import { createAction, props } from '@ngrx/store';
import { StrategicImperative } from '../../models/strategic-imperative.model';

export const loadStrategicImperatives = createAction('[Strategic Imperatives] Load Strategic Imperatives');

export const loadStrategicImperativesSuccess = createAction('[Strategic Imperatives] Load Strategic Imperatives Success', props<{ imperatives: StrategicImperative[] }>());

export const loadStrategicImperativesFailure = createAction('[Strategic Imperatives] Load Strategic Imperatives Failure', props<{ error: any }>());

export const addStrategicImperative = createAction('[Strategic Imperatives] Add Strategic Imperative', props<{ imperative: Partial<StrategicImperative> }>());

export const addStrategicImperativeSuccess = createAction('[Strategic Imperatives] Add Strategic Imperative Success', props<{ imperative: StrategicImperative }>());

export const addStrategicImperativeFailure = createAction('[Strategic Imperatives] Add Strategic Imperative Failure', props<{ error: any }>());

export const updateStrategicImperative = createAction('[Strategic Imperatives] Update Strategic Imperative', props<{ id: number; changes: Partial<StrategicImperative> }>());

export const updateStrategicImperativeSuccess = createAction('[Strategic Imperatives] Update Strategic Imperative Success', props<{ imperative: StrategicImperative }>());

export const updateStrategicImperativeFailure = createAction('[Strategic Imperatives] Update Strategic Imperative Failure', props<{ error: any }>());
